var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _path10, _path11, _ellipse3, _ellipse4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarAndPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 324.272,
    height: 142.73,
    viewBox: "0 0 324.272 142.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1577",
    "data-name": "Rectangle 1577",
    width: 151.309,
    height: 137.533,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.327,
    y1: 0.269,
    x2: 7.938,
    y2: 1.571,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.576,
    y1: 0.298,
    x2: 0.379,
    y2: 0.822,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "car_and_people",
    "data-name": "car and people",
    transform: "translate(-20 -232.27)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "People",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 2799.833, -7996.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(-2318 8315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7435",
    "data-name": "Group 7435",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4884",
    "data-name": "Path 4884",
    d: "M222.392,267.066c.734-.1,2.164.322,2.705.093s1.4-1.244,2.312-1.008,2.758,2.585,3.448,3.127,2.434.99,2.744,2.1a1.07,1.07,0,0,1-1.07,1.071h-9.314a1.655,1.655,0,0,1-1.633-1.428c-.12-.881.07-3.86.809-3.957",
    transform: "translate(-112.323 -134.917)",
    fill: "#111f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    d: "M143.067,260.118c.738.057,2.051.762,2.627.65s1.627-.928,2.471-.508,2.164,3.1,2.727,3.773,2.177,1.472,2.249,2.624a1.07,1.07,0,0,1-1.269.826l-9.112-1.926a1.656,1.656,0,0,1-1.3-1.735c.065-.886.868-3.762,1.61-3.7",
    transform: "translate(-71.715 -131.876)",
    fill: "#111f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4886",
    "data-name": "Path 4886",
    d: "M91.872,260.641c.734-.1,2.164.322,2.705.093s1.4-1.244,2.312-1.008,2.758,2.585,3.449,3.127,2.434.99,2.743,2.1a1.071,1.071,0,0,1-1.071,1.071H92.7a1.656,1.656,0,0,1-1.634-1.428c-.119-.881.071-3.86.81-3.957",
    transform: "translate(-46.151 -131.659)",
    fill: "#ee4e8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4887",
    "data-name": "Path 4887",
    d: "M4.671,210.413c.4.624.64,2.092,1.079,2.484s1.724.734,1.9,1.656-1.16,3.6-1.346,4.454.152,2.623-.721,3.378a1.071,1.071,0,0,1-1.427-.506h0l-3.994-8.4a1.654,1.654,0,0,1,.59-2.089c.746-.488,3.519-1.6,3.923-.973",
    transform: "translate(0 -106.582)",
    fill: "#ee4e8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4888",
    "data-name": "Path 4888",
    d: "M28.574,113.375c.087-7.415,4.358-11.964,6.887-15.04,1.428-1.736,2.829-3.1,3.781-4.483a4.608,4.608,0,0,0,.619-2.216c6.812,1.509,14.4-.012,16.98-.63,2.814,11.59,6,25.045,5.97,30.135-.1,16.64-2.447,28.171-8.546,54.392-.3,1.309-6.852.109-8.044-1.236-3.468-3.9-1.8-19.047,1.872-31.323,1.1-3.7-1.845-24.111-2.65-24.017-.394.048.735,22.935-10.147,33.375-5.04,4.828-13.231,5.549-24.314,2.712-2.037-.518-2.3-2.08-3.088-4.038-1.743-4.312,17.88-5.691,20.229-8.669,2.926-3.709.438-27.862.451-28.961",
    transform: "translate(-3.947 -46.139)",
    fill: "#1b4799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4889",
    "data-name": "Path 4889",
    d: "M91.4,154.87c.45,9.393-2.89,21.222-1.445,28.988a21.4,21.4,0,0,0,4.347,9.5c-.741,3.3-1.552,6.842-2.458,10.717-.3,1.309-6.852.109-8.045-1.236-3.467-3.9-1.8-19.047,1.872-31.323,1.1-3.7-1.845-24.111-2.65-24.016,0,0,7.926-2.025,8.379,7.367",
    transform: "translate(-41.519 -74.689)",
    fill: "#111f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4890",
    "data-name": "Path 4890",
    d: "M28.131,148.837c2.936-3.712.439-27.86.452-28.958.084-7.415,4.358-11.964,6.884-15.04.289-.344.573-.68.863-1.006,1.614,6.51,3.966,17.751,2.242,22.005-2.5,6.141-3.161,6.863-4.394,16.737s-7.014,11.2-5.086,16.5c.412,1.138.734,2.111.979,2.952-4.854,1.747-11.236,1.525-19.074-.483-2.036-.518-2.3-2.08-3.087-4.038-1.752-4.314,17.873-5.685,20.222-8.666",
    transform: "translate(-3.954 -52.642)",
    fill: "#111f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4891",
    "data-name": "Path 4891",
    d: "M182.729,106.573c-7.727,5.018-20.93-1.751-26.427-3.189a24.287,24.287,0,0,1-2.312,8.334c-5.772,12.25-1.4,29.567-3.6,36.822-.921,3.044-5.8,19.21-8.52,32.7-.377,1.89,9.626,3.586,10.393,1.729,4.691-11.333,8.816-21.625,10.019-25.743,3.471-11.891,6.507-34.891,9.548-27.628.529,1.259,1.678,12,1.512,13.653-.516,5.34,3.331,42.06,9.75,43.4,5.507,1.153,6.548-.161,6.712-2.885.6-9.836-4.734-71.052-7.077-77.189",
    transform: "translate(-71.922 -52.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4892",
    "data-name": "Path 4892",
    d: "M141.872,188.589c2.716-13.486,7.6-29.652,8.52-32.7,2.193-7.256-2.174-24.572,3.6-36.823.189-.4.363-.8.528-1.19a8.347,8.347,0,0,1,3.495,5.772c.5,6.339-1.464,26.329-3.495,36.405-1.512,7.511-6.414,23.147-8.816,30.623-2.167-.473-4-1.264-3.831-2.092",
    transform: "translate(-71.922 -59.764)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4893",
    "data-name": "Path 4893",
    d: "M202.809,168.763c.158-1.65-.989-12.389-1.519-13.654a2.554,2.554,0,0,0-.919-1.314s4,.025,4.659,6.373,6.745,41.535,7.477,45.436c.369,1.972.718,4.608.973,6.734-.29-.05-.594-.107-.915-.176-6.427-1.344-10.273-38.058-9.755-43.4",
    transform: "translate(-101.585 -77.972)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4894",
    "data-name": "Path 4894",
    d: "M92.073,45.835c5.651,1.106,9.791,22.285,9.791,22.285s19.375,25.429,16.646,30.392S97.453,78.819,94.7,70.219,83.817,44.225,92.073,45.835",
    transform: "translate(-44.852 -23.185)",
    fill: "#fca2c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4895",
    "data-name": "Path 4895",
    d: "M68.285,69.67c1.167-1.363,2.273-2.494,3.057-3.636A6.128,6.128,0,0,0,72.4,63.726c.97-4.792-8.7-7.9-3.8-13.82,2.114-2.556,4.128-4.619,11.02-4.215,1.155.074,2.629,3.71,3.587,4.964,2,2.6-.479,5.331,1.266,11.388.675,2.371,1.449,5.209,2.236,8.219-2.777,1.461-8.637,3.106-18.427-.591",
    transform: "translate(-34.074 -23.139)",
    fill: "#ee4e8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4896",
    "data-name": "Path 4896",
    d: "M80.454,38.369l.049,5.085c.012.835,2.125,2.936,3.415,1.855.381-.32-.16-1.462-.542-2.322l-1.094-4.349Z",
    transform: "translate(-40.789 -19.453)",
    fill: "#fca2c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4897",
    "data-name": "Path 4897",
    d: "M83.239,42.089a2.9,2.9,0,0,1-2.211-2.026l1.72.062Z",
    transform: "translate(-41.08 -20.311)",
    fill: "#e983af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4898",
    "data-name": "Path 4898",
    d: "M202.377,32.608c7.039-4.987,16.707,17.112,22.346,20.184,5.479,2.973,23.709,0,23.709,0s2.985,9.533.921,11.855-22.985,5.159-29.3,2.138c-10.208-4.928-23.523-30.037-17.677-34.177",
    transform: "translate(-101.878 -16.162)",
    fill: "#0d1e57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4899",
    "data-name": "Path 4899",
    d: "M177.994,2.872c.11-1.45,2.68-1.388,2.68-1.388s.06-1.7,2.382-1.462,2.187,3.451,2.187,3.451a1.358,1.358,0,0,1,1.585.43,3.575,3.575,0,0,1,.258,2.469s1.277,2.113-.258,3.513a1.634,1.634,0,0,1-1.548.135,5.949,5.949,0,0,1-2.494.725c-4.619-1.966-5.135-3.919-4.191-5.761-.4-.183-.674-1.117-.6-2.112",
    transform: "translate(-90.235 0)",
    fill: "#111f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4900",
    "data-name": "Path 4900",
    d: "M156.4,36.738c2.825-8.574,19.815-13.771,28.525-4.791,3.352,3.451,3.636,6.068,3.513,19.839-.012,2.039,7.592,14.042,5.528,18.12-.381.763-10.147,11.906-10.147,11.906L182.409,73.1l-10.982,1.142s-2.371,8.563-3.378,8.6c-5.2.209-9.754-8.685-9.68-9.582,1-11.585-3.846-30.823-1.966-36.523",
    transform: "translate(-79.072 -13.817)",
    fill: "#0d1e57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4901",
    "data-name": "Path 4901",
    d: "M181.88,24.318s-3.526.835-4.7,1.831-1.634,3.5-1.634,3.5l4.191.921s7.285-1.867,9.754-1.831c.01-.011-2.754-5.269-7.606-4.422",
    transform: "translate(-88.997 -12.282)",
    fill: "#111f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4902",
    "data-name": "Path 4902",
    d: "M195.729,73.376s-2.911-45-8.046-45.478c-4.914-.455-5.368.651-5.442,2.53-.086,2.568,2.506,44.09,2.506,44.09a19.874,19.874,0,0,0,10.982-1.142",
    transform: "translate(-92.393 -14.092)",
    fill: "#87c8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4903",
    "data-name": "Path 4903",
    d: "M187.592,16.116l1.448,6.228c-.073.872-3.6,2.359-4.877,1.13-.369-.369.258-5.713.258-5.713Z",
    transform: "translate(-93.31 -8.171)",
    fill: "#fca2c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4904",
    "data-name": "Path 4904",
    d: "M184.087,24.452c.037-.592.086-1.228.135-1.806l2.631-.8c.01-.012.367,1.363-2.766,2.6",
    transform: "translate(-93.33 -11.077)",
    fill: "#eda5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4905",
    "data-name": "Path 4905",
    d: "M184.015,9.581l1.032,3.513a2.23,2.23,0,0,1-1.673,2.63,6.184,6.184,0,0,1-2.74.025c-.995-.148-1.474-1.118-1.437-2.42a12.011,12.011,0,0,1,.909-4.042c.764-1.842,3.061-1.94,3.909.3",
    transform: "translate(-90.85 -4.007)",
    fill: "#fca2c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4906",
    "data-name": "Path 4906",
    d: "M189.039,13.195a3.02,3.02,0,0,0,.221-.64c.1-.418.356-1.02.9-.553.8.664.123,2.862-.958,2.788-.8-.072-.418-1.079-.16-1.6",
    transform: "translate(-95.678 -5.999)",
    fill: "#eda5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4907",
    "data-name": "Path 4907",
    d: "M149.37,156c-.786-.2-.749-.958-1.216-1.118a10.742,10.742,0,0,1-2.346-2.125c-.246-.393,1.13-5.553,2.42-6s3.833,2.187,3.833,2.187l.11.394s1.818,3.292.958,3.378c-.467.049-1.364-.69-1.364-.69l-.172,2.3a1.658,1.658,0,0,1-1.2,1.585",
    transform: "translate(-73.908 -74.379)",
    fill: "#fca2c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4908",
    "data-name": "Path 4908",
    d: "M154.547,43.5a3.356,3.356,0,0,0-4.865-1.7c-1.229.713-2.344,3.059-3.38,5.015-2.531,4.8-8.022,44.321-4.619,47.161s9.767,3,10.54-.872c.7-3.467,5.714-38.576,2.323-49.608",
    transform: "translate(-71.284 -20.96)",
    fill: "#0d1e57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4909",
    "data-name": "Path 4909",
    d: "M291.163,73.045s-.971-2.3.085-3.685.884-3.352,1.549-3.6.27,2.014.466,2.433,2.162-.675,3.465-2.236.822.822.822.822,1.069-.823,1.167.345a4.954,4.954,0,0,1-.591,2.408s.749-.148-.086.97-4.838,4.741-6.877,2.542",
    transform: "translate(-147.409 -33.171)",
    fill: "#fca2c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4910",
    "data-name": "Path 4910",
    d: "M81.593,27.236a7.242,7.242,0,0,0,.356-5.159c-.934-2.641-4.423-2.432-5.97-1.216s-3.833,3.513-1.315,6.844c1.929,2.554,6.241,2.579,6.929-.468",
    transform: "translate(-37.284 -10.138)",
    fill: "#111f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4911",
    "data-name": "Path 4911",
    d: "M83.536,27.78a2.862,2.862,0,0,0-.394-.774,5.794,5.794,0,0,1-2.173,1.708,3.416,3.416,0,0,1-1.916.11l-.356.934a3.21,3.21,0,0,0,1.671,4.128,2.744,2.744,0,0,0,3.772-1.831c.564-1.671-.332-3.4-.6-4.275",
    transform: "translate(-39.78 -13.692)",
    fill: "#fca2c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4912",
    "data-name": "Path 4912",
    d: "M88.638,31.7a3.024,3.024,0,0,0,.135-.551c.049-.356.209-.872.7-.542.712.493.332,2.383-.577,2.4-.663.012-.427-.86-.258-1.3",
    transform: "translate(-44.846 -15.465)",
    fill: "#eda5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4913",
    "data-name": "Path 4913",
    d: "M77.247,17.659a2.74,2.74,0,0,0-.69-2.579c-1.108-.934-2.823.258-3.02,1.745s1.523,2.653,2.518,2.113a2.333,2.333,0,0,0,1.192-1.278",
    transform: "translate(-37.274 -7.477)",
    fill: "#111f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4914",
    "data-name": "Path 4914",
    d: "M78.606,31.291a2.886,2.886,0,0,1-.025-.565c.025-.356-.037-.9-.592-.664-.8.345-.553,2.334.086,2.469.174.025.6-.774.53-1.24",
    transform: "translate(-39.285 -15.213)",
    fill: "#eda5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4915",
    "data-name": "Path 4915",
    d: "M55.787,58.278c-2.3,5.553-11.734,11.265-11.658,13.157.1,2.592,1.978,21.424-3.292,21.608-4.865.173-5.7-18.327-4.25-23.7,1.536-5.639,15.589-18.157,18.255-16.069a4.374,4.374,0,0,1,.946,5",
    transform: "translate(-18.223 -26.894)",
    fill: "#fca2c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4916",
    "data-name": "Path 4916",
    d: "M43.317,130.015a9.786,9.786,0,0,0-.749,4.275c.16,2.3,1.29,5.442,1.72,4.594s-.184-4.422.8-4.4-.1,1.72.405,2.469,1.106-.725,1.2-3.587-1.842-6.043-3.378-3.353",
    transform: "translate(-21.575 -65.401)",
    fill: "#fca2c7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(20 283.872)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7439",
    "data-name": "Group 7439",
    transform: "translate(47.136 55.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7438",
    "data-name": "Group 7438",
    transform: "translate(128.077 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M17.842,15.9C17.842,7.681,12.561.915,5.79.086L0,0V31.808l5.79-.086C12.561,30.893,17.842,24.129,17.842,15.9Z",
    transform: "translate(13.454 0)",
    fill: "#1e1240"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 13.454,
    cy: 15.904,
    rx: 13.454,
    ry: 15.904,
    transform: "translate(0 0)",
    fill: "#311e69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M17.842,15.9C17.842,7.681,12.561.915,5.789.086L0,0V31.808l5.789-.086C12.561,30.893,17.842,24.129,17.842,15.9Z",
    transform: "translate(13.454 0.001)",
    fill: "#1e1240"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 13.454,
    cy: 15.904,
    rx: 13.454,
    ry: 15.904,
    transform: "translate(0 0)",
    fill: "#1e1240"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "car-2",
    "data-name": "car",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M199.851,38.105s-18.8-3.334-35.317-6.658c0,0-19.049-17.985-32.849-26.484a23.532,23.532,0,0,0-9.13-3.27c-16.4-2.255-80.563-8.139-116.577,31.1a22.157,22.157,0,0,0-5.84,14.8L0,64.1a6.421,6.421,0,0,0,6.365,6.472l19.252.158S26.55,59.3,40.808,56.065,56.032,70.972,56.032,70.972l69.744.585,26.352.218,47.727.395,6.561.054s9.488.078,9.554-7.8l.069-8.469C216.09,50.7,210.232,39.818,199.851,38.105Z",
    transform: "translate(12.445 0)",
    fill: "#0d1e57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M33.079,23.617,0,23.319S3.136,13.257,6.909,8.912,18.893-1.686,25.673.422,41.082,8.932,41.231,11.91a5.409,5.409,0,0,0,.095.7C42.386,18.324,38.406,23.666,33.079,23.617Z",
    transform: "translate(141.242 48.45)",
    fill: "#1e1240"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M33.078,23.619,0,23.319S3.138,13.257,6.911,8.911,18.894-1.686,25.679.422s15.41,8.51,15.557,11.49a5.472,5.472,0,0,0,.089.7C42.4,18.325,38.412,23.666,33.078,23.619Z",
    transform: "translate(20.545 47.358)",
    fill: "#1e1240"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M182.039,38.105s-16.545-3.334-31.646-6.658c0,0-17.412-17.985-30.025-26.484a20.357,20.357,0,0,0-8.35-3.27C97.03-.561,38.38-6.446,5.464,32.789a23.344,23.344,0,0,0-5.339,14.8L0,64.1a6.175,6.175,0,0,0,5.817,6.472l17.6.158S24.267,59.3,37.3,56.065,51.215,70.972,51.215,70.972l63.761.576,24.084.227a6.346,6.346,0,0,0,6.123-5.357c1.028-5.335,4.541-12.684,16.092-12.58,11.337.1,14.521,7.241,15.319,12.565a6.452,6.452,0,0,0,6.09,5.767l6,.054s8.672.078,8.732-7.8l.063-8.469C197.518,50.7,191.529,39.818,182.039,38.105Z",
    transform: "translate(2.887 0)",
    fill: "#0046a0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M63,25.364A109.886,109.886,0,0,0,46.327,7.781,33.254,33.254,0,0,0,25.085,0C16.373,0,4.167.024.186.084L0,24.794Z",
    transform: "translate(81.437 6.003)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M50.939,0l-.186,24.71L0,24.252S21.294.128,50.939,0Z",
    transform: "translate(25.08 6.037)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M176.588,23.829a6.452,6.452,0,0,0,6.09,5.767l6,.054s8.672.078,8.732-7.8l.019-2.527q-2.11.07-4.718.209c-12.3.673-24.574-13.753-38.521-13.66s-24.714,9.718-50.82,2.139S45.575,1.2,23.453,2.855C10.182,3.844,3.727,1.8.684,0A24.034,24.034,0,0,0,.125,5.014L0,21.526A6.175,6.175,0,0,0,5.818,28l17.6.158S24.267,16.722,37.3,13.491,51.215,28.4,51.215,28.4l63.761.576,24.077.227a6.346,6.346,0,0,0,6.123-5.357c1.029-5.335,4.541-12.684,16.092-12.58C172.606,11.367,175.791,18.505,176.588,23.829Z",
    transform: "translate(2.894 42.574)",
    fill: "#0046a0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M8.749.052,2.972,0a4.73,4.73,0,0,0-2.7,2.905c-.911,2.363.589,6.563,2.626,7l5.776.052a2.239,2.239,0,0,0,2.152-2.316l.039-5.234A2.246,2.246,0,0,0,8.749.052Z",
    transform: "translate(0 52.133)",
    fill: "#ee4e8d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M17.842,15.9C17.842,7.681,12.561.915,5.791.086L0,0V31.808l5.791-.086C12.561,30.893,17.842,24.129,17.842,15.9Z",
    transform: "translate(161.889 56.32)",
    fill: "#1e1240"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 13.454,
    cy: 15.904,
    rx: 13.454,
    ry: 15.904,
    transform: "translate(148.435 56.32)",
    fill: "#1e1240"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 6.76,
    cy: 9.028,
    rx: 6.76,
    ry: 9.028,
    transform: "translate(155.129 63.196)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M1.562,0A5.17,5.17,0,0,0,0,.244c2.981.943,5.2,4.515,5.2,8.782S2.98,16.867,0,17.808a5.164,5.164,0,0,0,1.562.246c3.727,0,6.762-4.042,6.762-9.028S5.3,0,1.562,0Z",
    transform: "translate(160.324 63.198)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M17.842,15.9C17.842,7.681,12.561.915,5.791.086L0,0V31.808l5.791-.086C12.561,30.893,17.842,24.129,17.842,15.9Z",
    transform: "translate(36.091 56.32)",
    fill: "#1e1240"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 13.454,
    cy: 15.904,
    rx: 13.454,
    ry: 15.904,
    transform: "translate(22.637 56.32)",
    fill: "#1e1240"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 6.76,
    cy: 9.028,
    rx: 6.76,
    ry: 9.028,
    transform: "translate(29.33 63.196)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M1.562,0A5.154,5.154,0,0,0,0,.244c2.981.943,5.2,4.515,5.2,8.782S2.979,16.867,0,17.808a5.156,5.156,0,0,0,1.562.246c3.727,0,6.76-4.042,6.76-9.028S5.3,0,1.562,0Z",
    transform: "translate(34.529 63.198)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M36.934,0S16.353,2.35,0,16.6H21.134Z",
    transform: "translate(33.4 8.895)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M.231,65.183C-.225,46.413.134.462.138,0H.831c0,.462-.373,46.4.093,65.157Z",
    transform: "translate(78.463 6.033)",
    fill: "#1e1240"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M.406,40.441A125.782,125.782,0,0,1,1.472,11.154C2.6,3.9,3.408.043,3.423,0H4.5A149.13,149.13,0,0,0,1.1,40.363Z",
    transform: "translate(21.655 30.289)",
    fill: "#1e1240"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M18.292,6.762a4.5,4.5,0,0,0-2.37-2.586C13.556,3.078.413-1.129.018.289S5.7,8.562,8.962,9.114C11.853,9.6,19.761,11.013,18.292,6.762Z",
    transform: "translate(191.355 49.99)",
    fill: "#e2e2e2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M.093,3.143A4.5,4.5,0,0,1,2.577.4c.216-.106.516-.242.88-.4A10.636,10.636,0,0,1,3.83,2.659L3.805,5.6C1.374,5.674-.439,5.135.093,3.143Z",
    transform: "translate(224.667 53.299)",
    fill: "#e2e2e2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M19.284,0C31.6,7.994,47.168,22.342,50.03,25.01H27.893A185.125,185.125,0,0,0,0,0Z",
    transform: "translate(127.668 6.003)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M12.956.848A225.982,225.982,0,0,1,38.527,21.824L0,0H10.277A4.648,4.648,0,0,1,12.956.848Z",
    transform: "translate(133.935 7.023)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M0,2.558C0,3.96,3.673,5.1,8.2,5.1s8.2,0,8.2-2.538c0-2.942-3.673-2.54-8.2-2.54S0,1.155,0,2.558Z",
    transform: "translate(82.172 36.093)",
    fill: "#0d1e57"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M0,2.558C0,3.96,3.673,5.1,8.2,5.1s8.2,0,8.2-2.538c0-2.942-3.671-2.54-8.2-2.54S0,1.155,0,2.558Z",
    transform: "translate(26.153 36.093)",
    fill: "#0d1e57"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarAndPeople);
export default __webpack_public_path__ + "static/media/CarAndPeople.6706a58d.svg";
export { ForwardRef as ReactComponent };